import gql from 'graphql-tag';

export const GET_COMPETITION_PAGE = gql`
  query GetCompetitionPage($cachedSlug: String!, $locale: String) {
    competitionPage(cachedSlug: $cachedSlug, locale: $locale) {
      body
      seoTitle
      seoDescription
      openGraphTitle
      openGraphDescription
      openGraphImage
      ldJson
      validationErrors
    }
  }
`;

export const GET_DYNAMIC_PAGE = gql`
  query GetDynamicPage($slug: String!, $locale: String) {
    page(slug: $slug, locale: $locale) {
      body
      header
    }
  }
`;

export const GET_DYNAMIC_PAGE_URL = gql`
  query GetDynamicPageUrl($url: String!, $locale: String) {
    page(url: $url, locale: $locale) {
      body
      seoTitle
      seoDescription
      openGraphTitle
      openGraphDescription
      openGraphImage
      ldJson
      validationErrors
    }
  }
`;

export const GET_PAGE = gql`
  query GetPage($slug: String!, $locale: String) {
    page(slug: $slug, locale: $locale) {
      body
      header
    }
  }
`;
